interface PropsType {
  count: number
}

const WorksCount = (props: PropsType) => {
  const worksCountNumber = props.count.toLocaleString()
  return (
    <div className="mr-4 w-60 text-right text-sm">
      ヒットする件数&nbsp;<span className="text-2xl font-bold">{worksCountNumber}</span>件
    </div>
  )
}

export default WorksCount
